import { ListSortOrder } from '@nextiva/engagement-ui';

import { CREATED_AT } from 'constants/templateList/TemplateListSortableFields';
import { ALL } from 'constants/templateList/TemplateTabKeys';
import { paginationLimit } from './Pagination';

const { DESCENDING } = ListSortOrder;

export default {
  sortOrder: DESCENDING,
  sortBy: CREATED_AT,
  paginationLimit,
  tabName: ALL,
};
